import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import { API } from '../config/api';

const MESES = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const inputStyle = { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', background: '#fff', fontFamily: 'Segoe UI, sans-serif' };
const fmt = (n) => (n == null || isNaN(n)) ? null : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const simbolo = (m) => m === 'Dólares' ? '$' : m === 'Euros' ? '€' : '₡';

export default function GastosRecurrentes() {
  const isAdmin = useAdmin();
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const registradoPor = accounts[0]?.name || accounts[0]?.username || null;

  const ahora = new Date();
  const [anio, setAnio] = useState(ahora.getFullYear());
  const [mes, setMes] = useState(ahora.getMonth() + 1);
  const [data, setData] = useState({ plantillas: [], resumen: { total: 0, generadas: 0, pendientes: 0 } });
  const [cargando, setCargando] = useState(true);
  const [generando, setGenerando] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, [anio, mes]);

  const cargar = async () => {
    setCargando(true); setMsg('');
    try {
      const r = await axios.get(`${API}/gastos-recurrentes?anio=${anio}&mes=${mes}`);
      setData(r.data || { plantillas: [], resumen: { total: 0, generadas: 0, pendientes: 0 } });
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const generar = async () => {
    if (!window.confirm(`¿Generar los gastos recurrentes de ${MESES[mes]} ${anio}? Solo se crean los que falten.`)) return;
    setGenerando(true); setMsg('');
    try {
      const r = await axios.post(`${API}/gastos-recurrentes?action=generar`, { anio: parseInt(anio), mes: parseInt(mes), registrado_por: registradoPor });
      const d = r.data;
      setMsg(`Generados: ${d.generados}. Ya existian: ${d.ya_existian}.`);
      await cargar();
    } catch (e) { setMsg('Error: ' + (e.response?.data?.error || e.message)); }
    finally { setGenerando(false); }
  };

  const { resumen } = data;

  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1100px' }}>
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Gastos recurrentes</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          {isAdmin && <button onClick={() => navigate('/app/gastos/catalogos')} style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.12)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Administrar plantillas</button>}
          {isAdmin && (
            <button onClick={generar} disabled={generando || resumen.pendientes === 0}
              style={{ padding: '8px 16px', background: resumen.pendientes ? '#87B749' : '#9bb', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: resumen.pendientes ? 'pointer' : 'not-allowed', opacity: generando ? 0.7 : 1 }}>
              {generando ? 'Generando...' : `Generar recurrentes de ${MESES[mes]} ${anio}`}
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', alignItems: 'center' }}>
        <select style={inputStyle} value={anio} onChange={e => setAnio(e.target.value)}>
          {[ahora.getFullYear() + 1, ahora.getFullYear(), ahora.getFullYear() - 1].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={inputStyle} value={mes} onChange={e => setMes(e.target.value)}>
          {MESES.slice(1).map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
        </select>
      </div>

      {/* Banner resumen */}
      <div style={{ background: '#e6f1fb', border: '1px solid #B5D4F4', borderRadius: '10px', padding: '12px 18px', marginBottom: '14px', fontSize: '13px', color: '#185FA5', fontWeight: '600' }}>
        {resumen.total} plantilla(s) mensual(es) · {resumen.generadas} generada(s) · {resumen.pendientes} pendiente(s) para {MESES[mes]} {anio}
      </div>

      {msg && <div style={{ background: '#EAF3DE', border: '1px solid #b8dfc8', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#3B6D11', marginBottom: '14px' }}>{msg}</div>}

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
        {cargando ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Cargando...</div>
        ) : data.plantillas.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No hay plantillas recurrentes. {isAdmin ? 'Creá una en Administrar plantillas.' : ''}</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['Plantilla', 'Categoria', 'Empresa', 'Periodicidad', 'Monto sugerido', 'Estado del mes'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: h === 'Monto sugerido' ? 'right' : 'left', color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.plantillas.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid #f3f3f3', opacity: p.activo ? 1 : 0.5 }}>
                  <td style={{ padding: '10px 14px', color: '#1a1a1a', fontWeight: '500' }}>{p.nombre}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{p.categoria_nombre}{p.subcategoria_nombre ? ` · ${p.subcategoria_nombre}` : ''}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{p.empresa}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{p.periodicidad}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', color: '#012E40', fontWeight: '600' }}>
                    {fmt(p.monto_sugerido) ? `${simbolo(p.moneda)}${fmt(p.monto_sugerido)}` : <span style={{ color: '#bbb', fontWeight: '400' }}>variable</span>}
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    {p.periodicidad !== 'Mensual'
                      ? <span style={{ color: '#bbb', fontSize: '12px' }}>— (no mensual)</span>
                      : p.estado_mes === 'Generado'
                        ? <span style={{ background: '#e6f1fb', color: '#185FA5', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>Generado</span>
                        : <span style={{ background: '#fff4e0', color: '#854F0B', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>Pendiente</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
